import { combineReducers } from "redux";
import agreement from "./agreement/reducers";

export default combineReducers({
  agreement,
});
